import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SubWorkspacesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SubWorkspacesQuery = { subWorkspaces?: Array<{ id: string, name: string }> | null };


export const SubWorkspacesDocument = /*#__PURE__*/ gql`
    query subWorkspaces {
  subWorkspaces {
    id
    name
  }
}
    `;

export function useSubWorkspacesQuery(options?: Omit<Urql.UseQueryArgs<SubWorkspacesQueryVariables>, 'query'>) {
  return Urql.useQuery<SubWorkspacesQuery, SubWorkspacesQueryVariables>({ query: SubWorkspacesDocument, ...options });
};